<template>
  <b-table
    :data="emailLogs"
    ref="table"
    paginated
    per-page="10"
    detail-key="id"
    aria-next-label="Next page"
    aria-previous-label="Previous page"
    aria-page-label="Page"
    aria-current-label="Current page"
  >
    <b-table-column
      v-if="!isProject"
      field="project"
      label="Project"
      v-slot="props"
      sortable
    >
      {{ props.row.project.name }}
    </b-table-column>
    <b-table-column v-else field="email" label="Email" v-slot="props">
      {{ props.row.email }}
    </b-table-column>
    <b-table-column field="subject" label="Subject" v-slot="props" sortable>
      {{ props.row.subject }}
    </b-table-column>
    <b-table-column field="type" label="Type" v-slot="props" sortable>
      {{ props.row.type }}
    </b-table-column>
    <b-table-column field="status" label="Status" v-slot="props" sortable>
      {{ props.row.status }}
    </b-table-column>
    <b-table-column field="dateSent" label="Date Sent" v-slot="props" sortable>
      <b-tooltip
        position="is-left"
        :label="datetime(props.row.created_at)"
        type="is-success"
      >
        <span class="tag is-success">
          {{ dateFromNow(props.row.created_at) }}
        </span>
      </b-tooltip>
    </b-table-column>
    <b-table-column
      field="opened"
      label="Opened"
      v-slot="props"
      sortable
      centered
    >
      <b-icon v-if="props.row.is_read" pack="fas" icon="check" size="is-small">
      </b-icon>
      <b-icon v-else pack="fas" icon="times" size="is-small"> </b-icon>
    </b-table-column>
  </b-table>
</template>

<script>
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  props: {
    emailLogs: Array,
    isProject: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    dateFromNow(date) {
      return dayjs(date).fromNow();
    },
    datetime(date) {
      return (
        dayjs(date).format('YYYY-MM-DD, H:mm:ss') ?? 'Error: Date not found'
      );
    },
  },
};
</script>
